import { useQuery } from "@tanstack/react-query";
import { userApi } from "../services/user.api";
import { TUserFilter } from "../../../interfaces/userInterface";
import { IApiPagination } from "../../../interfaces/IPagination";

export type UseUsersQueryParams = {
  filter: TUserFilter;
  pagination: IApiPagination;
};

export const useUsersQuery = (params: UseUsersQueryParams) => {
  return useQuery({
    queryKey: ["users", params],
    queryFn: async () => {
      const res = await userApi.getUsers(params.filter, params.pagination);
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};

export const useUserByIdQuery = (userId?: string) => {
  return useQuery({
    queryKey: ["user-by-id", userId],
    queryFn: () => userApi.getUserById(userId as string),
    staleTime: 1000 * 60, // 1 minute
    enabled: !!userId,
  });
};
